import { FileUploader } from "react-drag-drop-files";
import { useSelector, useDispatch } from 'react-redux'
import { CloudUploadOutlined } from '@ant-design/icons';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import { useEffect } from 'react';
import { Upload } from 'antd';
import {
  setFile, getFilename, getStyle, getBizID, getObjective, getObjectiveCheck, getFileAlertShow, getFileAlertMessage, getFileAlertColor, setFileAlert
} from '../../libs/todoSlice'
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { es } from "date-fns/locale";

export default function ExcelImport() {
  const dispatch = useDispatch()
  const fileNameStore = useSelector(getFilename)
  const style = useSelector(getStyle)
  const navigate = useNavigate()
  const params = useParams()
  const showAlert = useSelector(getFileAlertShow)
  const alertMessage = useSelector(getFileAlertMessage)
  const alertColor = useSelector(getFileAlertColor)
  const { Dragger } = Upload;
  useEffect(() => {
    if (showAlert) {
      setTimeout(() => {
        dispatch(setFileAlert({
          file_alert_show: false,
          file_alert_color: '',
          file_alert_message: '',
        }))
      }, 3000)
    }
  }, [showAlert]);
  const readFile = (info) => {
    return new Promise((resolve, reject) => {
      const xlsx = require('xlsx')
      if (info) {
        const reader = new FileReader();
        reader.readAsArrayBuffer(info);
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = xlsx.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = xlsx.utils.sheet_to_json(worksheet);
          reader.json = json;
          resolve({ json: json, info: info })
        };
      } else {
        resolve({ json: [], info: info })
      }
    })
  }
  const onChange = async (e) => {
    // readFile(info).then(({json, info}) => {
    //   setStore(json, info)
    // })
    const extension = e.name.split('.')?.[1]
    if (extension !== 'xlsx' && extension !== 'xls') {
      console.log('extension', extension)
      dispatch(setFileAlert({
        file_alert_show: true,
        file_alert_color: 'error',
        file_alert_message: 'ไฟล์ไม่ถูกต้อง',
      }))

      dispatch(setFile({
        file: [],
        filename: '',
        file_id: ''
      }))
    } else {
      const { json, info } = await readFile(e)
      await setStore(json, info)
    }
  }

  const objective = useSelector(getObjective)
  const checkCase = (json) => {
    let scopes = [...objective]
    if (objective.length === 1) {
      return (
        (json[1].cid !== undefined ? json[1].cid.replaceAll('\r', '') === "เลขประจำตัวประชาชน\n(Identification Card) (ถ้ามี)\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
        (json[1].email !== undefined ? ["อีเมล", "อีเมล\n(อีเมลเจ้าของใบรับรอง)"].includes(json[1].email.replaceAll('\r', '')) : false) &&
        (json[1].index !== undefined ? json[1].index.replaceAll('\r', '') === "ลำดับที่" : false) &&
        (json[1].mobile !== undefined ? json[1].mobile.replaceAll('\r', '') === "โทรศัพท์มือถือ\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
        (json[1].name_eng !== undefined ? json[1].name_eng.replaceAll('\r', '') === "ชื่อ\n(ภาษาอังกฤษ)" : false) &&
        (json[1].name_th !== undefined ? json[1].name_th.replaceAll('\r', '') === "ชื่อ\n(ภาษาไทย)" : false) &&
        (json[1].surname_eng !== undefined ? json[1].surname_eng.replaceAll('\r', '') === "นามสกุล\n(ภาษาอังกฤษ)" : false) &&
        (json[1].surname_th !== undefined ? json[1].surname_th.replaceAll('\r', '') === "นามสกุล\n(ภาษาไทย)" : false) &&
        (json[1].tel !== undefined ? json[1].tel.replaceAll('\r', '') === "โทรศัพท์ (ถ้ามี)\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
        (json[1].title_th !== undefined ? json[1].title_th.replaceAll('\r', '') === "คำนำหน้า" : false) &&
        (json[1].position !== undefined ? ["ตำแหน่ง (T) (ถ้ามี)\n(ภาษาไทย หรือ ภาษาอังกฤษ)", "ตำแหน่ง\n(ภาษาไทย หรือ ภาษาอังกฤษ)"].includes(json[1].position.replaceAll('\r', '')) : false) &&
        (json[1].department !== undefined ? ["แผนก (T) (ถ้ามี)\n(ภาษาไทย หรือ ภาษาอังกฤษ)", "แผนก\n(ภาษาไทย หรือ ภาษาอังกฤษ)"].includes(json[1].department.replaceAll('\r', '')) : false) &&
        (json[1].biz_email !== undefined ? ["อีเมลองค์กร", "อีเมลองค์กร (ถ้ามี)"].includes(json[1].biz_email.replaceAll('\r', '')) : false) &&
        (json[1].employee_id !== undefined ? json[1].employee_id.replaceAll('\r', '') === "รหัสพนักงาน" : false)
        // (json[1].username !== undefined ? json[1].username.replaceAll('\r', '') === "Username" : false)

      )
    } else {
      let valid = true
      if (scopes.includes('CA') && (params.prefix === "pmuc" && params.prefix === "pmub")) {
        valid = (
          (json[1].address !== undefined ? json[1].address.replaceAll('\r', '') === "ที่อยู่ของหน่วยงาน" : false) &&
          (json[1].cid !== undefined ? json[1].cid.replaceAll('\r', '') === "เลขประจำตัวประชาชน\n(Identification Card) (ถ้ามี)\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
          (json[1].email !== undefined ? json[1].email.replaceAll('\r', '') === "อีเมล\n(อีเมลเจ้าของใบรับรอง)" : false) &&
          (json[1].index !== undefined ? json[1].index.replaceAll('\r', '') === "ลำดับที่" : false) &&
          (json[1].maintainer_email_1 !== undefined ? json[1].maintainer_email_1.replaceAll('\r', '') === "อีเมล (คนที่ 1)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_email_2 !== undefined ? json[1].maintainer_email_2.replaceAll('\r', '') === "อีเมล (คนที่ 2)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_name_1 !== undefined ? json[1].maintainer_name_1.replaceAll('\r', '') === "ชื่อ (คนที่ 1)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_name_2 !== undefined ? json[1].maintainer_name_2.replaceAll('\r', '') === "ชื่อ (คนที่ 2)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_surname_1 !== undefined ? json[1].maintainer_surname_1.replaceAll('\r', '') === "นามสกุล (คนที่ 1)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_surname_2 !== undefined ? json[1].maintainer_surname_2.replaceAll('\r', '') === "นามสกุล (คนที่ 2)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_tel_1 !== undefined ? json[1].maintainer_tel_1.replaceAll('\r', '') === "โทรศัพท์มือถือ (คนที่ 1)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_tel_2 !== undefined ? json[1].maintainer_tel_2.replaceAll('\r', '') === "โทรศัพท์มือถือ (คนที่ 2)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          
          (json[1].maintainer_email_3 !== undefined ? json[1].maintainer_email_3.replaceAll('\r', '') === "อีเมล (คนที่ 3)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_email_4 !== undefined ? json[1].maintainer_email_4.replaceAll('\r', '') === "อีเมล (คนที่ 4)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_name_3 !== undefined ? json[1].maintainer_name_3.replaceAll('\r', '') === "ชื่อ (คนที่ 3)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_name_4 !== undefined ? json[1].maintainer_name_4.replaceAll('\r', '') === "ชื่อ (คนที่ 4)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_surname_3 !== undefined ? json[1].maintainer_surname_3.replaceAll('\r', '') === "นามสกุล (คนที่ 3)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_surname_4 !== undefined ? json[1].maintainer_surname_4.replaceAll('\r', '') === "นามสกุล (คนที่ 4)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_tel_3 !== undefined ? json[1].maintainer_tel_3.replaceAll('\r', '') === "โทรศัพท์มือถือ (คนที่ 3)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].maintainer_tel_4 !== undefined ? json[1].maintainer_tel_4.replaceAll('\r', '') === "โทรศัพท์มือถือ (คนที่ 4)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&

          (json[1].mobile !== undefined ? json[1].mobile.replaceAll('\r', '') === "โทรศัพท์มือถือ\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
          (json[1].name_eng !== undefined ? json[1].name_eng.replaceAll('\r', '') === "ชื่อ\n(ภาษาอังกฤษ)" : false) &&
          (json[1].name_th !== undefined ? json[1].name_th.replaceAll('\r', '') === "ชื่อ\n(ภาษาไทย)" : false) &&
          (json[1].organization !== undefined ? json[1].organization.replaceAll('\r', '') === "ชื่อองค์กรที่เจ้าของใบรับรองสังกัด (O)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].position !== undefined ? json[1].position.replaceAll('\r', '') === "ตำแหน่งของเจ้าของใบรับรอง (T) (ถ้ามี)\n(ภาษาไทย หรือ ภาษาอังกฤษ)" : false) &&
          (json[1].sub_organization !== undefined ? json[1].sub_organization.replaceAll('\r', '') === "ชื่อของหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด (OU (ถ้ามี)\n(ภาษาไทย หรือ ภาษาอังกฤษ)" : false) &&
          (json[1].surname_eng !== undefined ? json[1].surname_eng.replaceAll('\r', '') === "นามสกุล\n(ภาษาอังกฤษ)" : false) &&
          (json[1].surname_th !== undefined ? json[1].surname_th.replaceAll('\r', '') === "นามสกุล\n(ภาษาไทย)" : false) &&
          (json[1].tax_id !== undefined ? json[1].tax_id.replaceAll('\r', '') === "เลขประจำตัวผู้เสียภาษีอากรของนิติบุคคล\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].tel !== undefined ? json[1].tel.replaceAll('\r', '') === "โทรศัพท์ (ถ้ามี)\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
          (json[1].title_th !== undefined ? json[1].title_th.replaceAll('\r', '') === "คำนำหน้า" : false)
          // (json[1].username !== undefined ?? json[1].username.replaceAll('\r', '') === "Username")
        )
      } else if (scopes.includes('CA') && (params.prefix !== "pmuc" && params.prefix !== "pmub")) {
        console.log('params.prefix', params.prefix)
        valid = (
          // (json[1].address !== undefined ? json[1].address.replaceAll('\r', '') === "ที่อยู่ของหน่วยงาน" : false) &&
          (json[1].cid !== undefined ? json[1].cid.replaceAll('\r', '') === "เลขประจำตัวประชาชน\n(Identification Card) (ถ้ามี)\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
          (json[1].email !== undefined ? json[1].email.replaceAll('\r', '') === "อีเมล\n(อีเมลเจ้าของใบรับรอง)" : false) &&
          (json[1].index !== undefined ? json[1].index.replaceAll('\r', '') === "ลำดับที่" : false) &&
          // (json[1].maintainer_email_1 !== undefined ? json[1].maintainer_email_1.replaceAll('\r', '') === "อีเมล (คนที่ 1)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          // (json[1].maintainer_email_2 !== undefined ? json[1].maintainer_email_2.replaceAll('\r', '') === "อีเมล (คนที่ 2)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          // (json[1].maintainer_name_1 !== undefined ? json[1].maintainer_name_1.replaceAll('\r', '') === "ชื่อ (คนที่ 1)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          // (json[1].maintainer_name_2 !== undefined ? json[1].maintainer_name_2.replaceAll('\r', '') === "ชื่อ (คนที่ 2)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          // (json[1].maintainer_surname_1 !== undefined ? json[1].maintainer_surname_1.replaceAll('\r', '') === "นามสกุล (คนที่ 1)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          // (json[1].maintainer_surname_2 !== undefined ? json[1].maintainer_surname_2.replaceAll('\r', '') === "นามสกุล (คนที่ 2)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          // (json[1].maintainer_tel_1 !== undefined ? json[1].maintainer_tel_1.replaceAll('\r', '') === "โทรศัพท์มือถือ (คนที่ 1)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          // (json[1].maintainer_tel_2 !== undefined ? json[1].maintainer_tel_2.replaceAll('\r', '') === "โทรศัพท์มือถือ (คนที่ 2)\n(ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].mobile !== undefined ? json[1].mobile.replaceAll('\r', '') === "โทรศัพท์มือถือ\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
          (json[1].name_eng !== undefined ? json[1].name_eng.replaceAll('\r', '') === "ชื่อ\n(ภาษาอังกฤษ)" : false) &&
          (json[1].name_th !== undefined ? json[1].name_th.replaceAll('\r', '') === "ชื่อ\n(ภาษาไทย)" : false) &&
          // (json[1].organization !== undefined ? json[1].organization.replaceAll('\r', '') === "ชื่อองค์กรที่เจ้าของใบรับรองสังกัด (O)\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].position !== undefined ? json[1].position.replaceAll('\r', '') === "ตำแหน่งของเจ้าของใบรับรอง (T) (ถ้ามี)\n(ภาษาไทย หรือ ภาษาอังกฤษ)" : false) &&
          // (json[1].sub_organization !== undefined ? json[1].sub_organization.replaceAll('\r', '') === "ชื่อของหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด (OU (ถ้ามี)\n(ภาษาไทย หรือ ภาษาอังกฤษ)" : false) &&
          (json[1].surname_eng !== undefined ? json[1].surname_eng.replaceAll('\r', '') === "นามสกุล\n(ภาษาอังกฤษ)" : false) &&
          (json[1].surname_th !== undefined ? json[1].surname_th.replaceAll('\r', '') === "นามสกุล\n(ภาษาไทย)" : false) &&
          // (json[1].tax_id !== undefined ? json[1].tax_id.replaceAll('\r', '') === "เลขประจำตัวผู้เสียภาษีอากรของนิติบุคคล\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
          (json[1].tel !== undefined ? json[1].tel.replaceAll('\r', '') === "โทรศัพท์ (ถ้ามี)\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
          (json[1].title_th !== undefined ? json[1].title_th.replaceAll('\r', '') === "คำนำหน้า" : false)
          // (json[1].username !== undefined ?? json[1].username.replaceAll('\r', '') === "Username")
        )
      }
      if (scopes.includes('เลขที่หนังสือสัญญา')) {
        valid = (
          (json[1].contract_no !== undefined ? json[1].contract_no.replaceAll('\r', '') === "เลขที่สัญญา" : false)
        )
      }
      return valid
    }
  }

  const business_id = useSelector(getBizID)
  const setStore = (json, info) => {
    const checked_json = json.filter((_, i) => i > 1)
    console.log('json[1]', json[1])
    if (json[1] === undefined || json[1] === null) {
      console.log('json[1]', json[1])

      dispatch(setFileAlert({
        file_alert_show: true,
        file_alert_color: 'error',
        file_alert_message: 'ไฟล์ไม่ถูกต้อง',
      }))

      dispatch(setFile({
        file: [],
        filename: '',
        file_id: ''
      }))
    } else {
      if (json.length > 502) {
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'error',
          file_alert_message: 'อัพโหลดครั้งละไม่เกิน 500 ข้อมูล',
        }))
        dispatch(setFile({
          file: [],
          filename: '',
          file_id: ''
        }))
      } else if (checkCase(json)) {
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'success',
          file_alert_message: 'สำเร็จ',
        }))
        dispatch(setFile({
          file: checked_json,
          filename: info.name,
        }))
        let formData = new FormData()
        formData.append('business_id', business_id)
        formData.append('excel', info)
        axios({
          method: 'POST',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
          data: formData,
        }).then(({ data, status }) => {
          dispatch(setFile({
            file: checked_json,
            filename: info.name,
            file_id: data.data._id
          }))
        }, ({ response }) => {
          const { status } = response
          if (status === 401) {
            navigate(`/${params.prefix}`)
          }
        })
      } else {
        // message.error('ไฟล์ไม่ถูกต้อง')
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'error',
          file_alert_message: 'ไฟล์ไม่ถูกต้อง',
        }))
        dispatch(setFile({
          file: [],
          filename: '',
          file_id: ''
        }))
      }
    }
  }
  const objectiveCheck = useSelector(getObjectiveCheck)

  const downloadForm = () => { 
    if ((objective.includes('one-id') || objective.includes('one-id-pmuc')) && objective.includes('CA') && objective.includes('เลขที่หนังสือสัญญา')) {
      window.open('/files/templates/oneid-ca-contract.xlsx', '_blank');
    } else if (objective.includes('one-id') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")) {
       window.open('/files/templates/export-excel-one-id-ca.xlsx', '_blank');
    } else if (objective.includes('one-id') && objective.includes('CA') && (params.prefix !== "pmuc" || params.prefix !== "pmub")) {
       window.open('/files/templates/export-excel-oneid-ca2.xlsx', '_blank');
    } else if (objective.includes('one-id-pmuc') && objective.includes('CA')) {
      window.open('/files/templates/oneid-ca-contract.xlsx', '_blank');
    } else if ((objective.includes('one-id') || objective.includes('one-id-pmuc')) && objective.includes('เลขที่หนังสือสัญญา')) {
      window.open('/files/templates/oneid-ca-contract.xlsx', '_blank');
    } else if ((objective.includes('one-id') || objective.includes('one-id-pmuc')) && objective.includes('Pre-register')) {
      window.open('/files/templates/oneid-preregis.xlsx', '_blank');
    } else if ((objective.includes('one-id')) && objectiveCheck.includes('ra')) {
      window.open('/files/templates/oneid-ra.xlsx', '_blank');
    } else if (objective.includes('one-id') || objective.includes('one-id-pmuc')) {
       window.open('/files/templates/export-excel-one-id.xlsx', '_blank');
    }
  }

  return (
    <>
      <span>แบบฟอร์มเพิ่มรายชื่อ :
        <button
          onClick={downloadForm}
          style={{
            border: 'none',
            background: 'none'
          }}>
          {/* {objective.map(o => {if(o === 'เลขที่หนังสือสัญญา') {return 'contract'} else {return o}}).join('-').toLowerCase().replaceAll(' ', '-')}.xlsx &nbsp; */}
          oneid-ca-contract.xlsx &nbsp;
          <Tooltip title={<span style={{ fontSize: '14px' }} >ดาวน์โหลดแบบฟอร์ม </span>} placement="right" >
            <DownloadIcon style={{ color: 'black' }} />
          </Tooltip>

        </button>
      </span>
      <br />
      <Dragger
        style={{
          display: 'none'
        }}
        accept={['.xlsx', '.xls', '.csv'].join(',')}
        beforeUpload={() => false}
        maxCount={1}
      >
        <p className="ant-upload-drag-icon">
          <CloudUploadOutlined />
        </p>
        <p className="ant-upload-text">ลากและวางเอกสารที่นี่</p>
        <p className="ant-upload-hint">
          หรือเลือกไฟล์ เฉพาะไฟล์ .xls และ .xlsx เท่านั้น
        </p>
      </Dragger>

      <FileUploader
        handleChange={onChange}
        style={{
          width: '100%',
        }}
        name="file"
        types={['xlsx', 'xls', 'csv']}
        children={<>
          <Dragger
            onClick={() => false}
            openFileDialogOnClick={false}
          >
            <p className="ant-upload-drag-icon">
              <CloudUploadOutlined style={{ color: style.primary_color ?? '#053075', }} />
            </p>
            <p className="ant-upload-text">ลากและวางเอกสารที่นี่</p>
            <p className="ant-upload-hint">
              หรือเลือกไฟล์ เฉพาะไฟล์ .xls และ .xlsx เท่านั้น
            </p>
          </Dragger>

        </>
        }
      />
      <span
        style={{
          color: 'red',
          fontSize: '14px'
        }}
      >
        *กรุณาอัปโหลดครั้งละไม่เกิน 500 รายชื่อ
      </span><br />
      {fileNameStore ? <><strong>Filename:</strong> {fileNameStore}</> : ''}
      {showAlert &&
        <Alert
          onClose={() => {
            dispatch(setFileAlert({
              file_alert_show: false,
              file_alert_color: '',
              file_alert_message: '',
            }))
          }}
          severity={alertColor}
        >
          {alertMessage}
        </Alert>
      }
    </>
  )
}